export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Für welche Klassenstufen ist Kunst Startklar?',
    answer:
      'Von Klasse 1 bis 10 — ein eigener Band pro Klassenstufe, für Grundschule und Sekundarstufe.',
  },
  {
    question: 'Ist es für mein Bundesland geeignet?',
    answer:
      'Ja. Die Bände sind kompetenzorientiert aufgebaut und passen zu den Lehrplänen aller Bundesländer.',
  },
  {
    question: 'Brauche ich besondere Materialien oder einen Brennofen?',
    answer:
      'Nein. Zu jedem Projekt gehört eine Materialliste mit günstigen Alternativen — alles funktioniert mit dem, was im Klassenzimmer liegt.',
  },
  {
    question: 'Welches Format bekomme ich?',
    answer:
      'Alle Bände und Boni als PDF — zum Ausdrucken oder digital am Whiteboard.',
  },
  {
    question: 'Wie erhalte ich das Paket?',
    answer: 'Sofort nach dem Kauf als Download.',
  },
  {
    question: 'Kann ich es für eine ganze Klasse oder mehrere Klassen nutzen?',
    answer:
      'Ja, du darfst die Vorlagen für deinen Unterricht beliebig oft ausdrucken.',
  },
  {
    question: 'Brauche ich Vorkenntnisse in Kunst, um es einzusetzen?',
    answer:
      'Nein. Jeder Arbeitsschritt ist als Bildfolge gezeichnet — auch fachfremd sofort einsetzbar.',
  },
  {
    question: 'Ist es einmalig zu bezahlen?',
    answer: 'Ja, du zahlst einmal 19 € und nutzt alles dauerhaft.',
  },
]
